module.exports = __webpack_public_path__ + "img/cmcc.a3c7d3f8.png";